'use strict';
// Declare app level module which depends on filters, and services
angular.module('autoremind', [
    //     'analytics',
    /**/
    'ngRoute',
    /* 'ngCookies',*/
    'ngSanitize',
    'ngAnimate',
    // Angular UI with Bootstrap
    //'ui.bootstrap',
    'ui.bootstrap.collapse', 'ui.bootstrap.tabindex', 'ui.bootstrap.accordion', 'ui.bootstrap.alert', 'ui.bootstrap.buttons', 'ui.bootstrap.carousel', 'ui.bootstrap.dateparser', 'ui.bootstrap.isClass', 'ui.bootstrap.datepicker', 'ui.bootstrap.position', 'ui.bootstrap.datepickerPopup', 'ui.bootstrap.debounce', 'ui.bootstrap.multiMap', 'ui.bootstrap.dropdown', 'ui.bootstrap.stackedMap', 'ui.bootstrap.modal', 'ui.bootstrap.paging', 'ui.bootstrap.pager', 'ui.bootstrap.pagination', 'ui.bootstrap.tooltip', 'ui.bootstrap.popover', 'ui.bootstrap.progressbar', 'ui.bootstrap.rating', 'ui.bootstrap.tabs', 'ui.bootstrap.timepicker', 'ui.bootstrap.typeahead',
    'ui.codemirror',
    'angular-scroll-dropdown',
    'toggle-switch',
    'dialogs.main',
    //'Timezones',
    'angularMoment',
    'infinite-scroll',
    'angular-inview',
    // App specific
    'localization',
    'LocalStorageModule',
    'autoremind.filters', 'autoremind.services', 'autoremind.directives',
    'autoremind.account.service',
    'autoremind.profile',
    'autoremind.logs',
    'autoremind.appointments.services',
    'autoremind.communications.services', 'autoremind.communications',
    'autoremind.messaging',
    'autoremind.csv', 'autoremind.csv.services',
    'autoremind.queries.services', 'autoremind.queries',
    /*'autoremind.support', */
    'autoremind.satellites.services', 'autoremind.satellites',
    'autoremind.users',
    'autoremind.admin',
    'autoremind.admin.chargify',
    'autoremind.reseller.services', 'autoremind.reseller',
    'autoremind.dev',
    'googlechart',
    'autoremind.reports',
    'autoremind.reports.communication',
    'autoremind.reports.config',
    'autoremind.reports.filters',
    'autoremind.reports.todo',
    'autoremind.reports.unsubscribe',
    'autoremind.reports.contacts',
    'autoremind.dashboard.directives',
    'autoremind.dashboard.services',
    'autoremind.dashboard.filters',
    'autoremind.dashboard.constants',
    'ui.sortable',
    'autoremind.reports.survey',
    'autoremind.dialogs',
    'autoremind.constants',
    'autoremind.templates',
    'ngFileUpload',
    'angularjs-dropdown-multiselect',
    'angularTreeview',
    'betsol.intlTelInput',
    'pascalprecht.translate'
])
    .config(['intlTelInputOptions', function (intlTelInputOptions) {
        angular.extend(intlTelInputOptions, {
            //  If disabled, there is no dropdown arrow, and the selected flag is not clickable
            allowDropdown: true,
            // if there is just a dial code in the input: remove it on blur, and re-add it on focus
            autoHideDialCode: true,
            // add a placeholder in the input with an example number for the selected country
            autoPlaceholder: "polite",
            // modify the auto placeholder
            customPlaceholder: null,
            // append menu to a specific element
            dropdownContainer: "",
            // don't display these countries
            excludeCountries: [],
            // format the input value during initialisation and on setNumber
            formatOnDisplay: true,
            // geoIp lookup function
            geoIpLookup: null,
            // inject a hidden input with this name, and on submit, populate it with the result of getNumber
            hiddenInput: "",
            // initial country
            initialCountry: "",
            // don't insert international dial codes
            nationalMode: false,
            // display only these countries
            onlyCountries: [],
            // number type to use for placeholders
            placeholderNumberType: "MOBILE",
            // the countries at the top of the list. defaults to united states and denmark
            preferredCountries: ["us", "dk"],
            // display the country dial code next to the selected flag so it's not part of the typed number
            separateDialCode: false,
            // specify the path to the libphonenumber script to enable validation/formatting
            utilsScript: ""
        });
    }])
    .config(['$routeProvider', '$locationProvider', '$qProvider',
    function ($routeProvider, $locationProvider, $qProvider) {
        $qProvider.errorOnUnhandledRejections(false);
        // Setup routes based on global routing table
        for (var i = 0; i < window.ROUTES.length; i++) {
            $routeProvider.when(window.ROUTES[i].routeUrl, {
                templateUrl: window.ROUTES[i].templateUrl,
                template: window.ROUTES[i].template,
                controller: window.ROUTES[i].controller,
                permissions: window.ROUTES[i].permissions,
                resolve: {
                    // On route change request the $$routeChangeStart event is fired and then
                    // this will make accountService check if user is logged in and if not delay route
                    // change until logged in. Either by auto-login or by using login prompt
                    resolveLogin: ['accountService', function (accountService) {
                            var promise = accountService.resolveLoginNg1()
                                .then(function () {
                                console.log('app.config(): Routing resolveLoginNg1 completed');
                            });
                            return promise;
                        }]
                }
            });
        }
        // $routeProvider.otherwise({redirectTo: '/dashboard'});
    }]);
/**
 * Configuring the angular-ui module
 */
angular.module('autoremind').
    value('ui.config', {
    date: {
        defaultDate: null,
        changeMonth: true,
        changeYear: true,
        yearRange: 'c-3:c+3',
        showWeek: false,
        dateFormat: 'mm/dd/yy',
        numberOfMonths: 1
    }
});
angular.module('autoremind')
    .config(['uibDatepickerConfig', 'uibDatepickerPopupConfig',
    function (datepickerConfig, datepickerPopupConfig) {
        datepickerConfig.showWeeks = false;
        datepickerConfig.yearFormat = 'yyyy';
        datepickerConfig.format = 'MM/dd/yyyy'; // NOTE: This does not seem to have any effect!
        datepickerConfig.startingDay = '7';
        datepickerPopupConfig.showButtonBar = false;
    }]);
angular.module('autoremind.constants', [])
    .constant('angularMomentConfig', {
    // preprocess: moment.utc,
    timezone: 'America/New_York' // default - will be set when user settings loaded
});
// To use moment-timezone we need to override moment (https://github.com/urish/angular-moment)
//.constant('moment', require('moment-timezone'));
//.constant('moment', momentTimezone);
// NOTE: We override moment in file.imports.ts in stead
angular.module('autoremind')
    .config(['$sceDelegateProvider', '$sceProvider',
    function ($sceDelegateProvider, $sceProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain.  Notice the difference between * and **.
            'https://www.youtube.com/embed/*',
            'http://www.autoremind.us/**',
            'http://www.autoremind.us/resellerportal/collateral*',
            'http://www.youtube.com/embed/*'
        ]);
        // The blacklist overrides the whitelist so the open redirect here is blocked.
        $sceDelegateProvider.resourceUrlBlacklist([
            'http://myapp.example.com/clickThru**'
        ]);
    }]);
angular.module('autoremind')
    .config(['$templateRequestProvider', function ($templateRequestProvider) {
        $templateRequestProvider.httpOptions({ _isTemplate: true });
    }]);
angular.module('autoremind')
    .config(['$translateProvider', function ($translateProvider) {
        var default_translation = {
            'DIALOG_MESSAGES': "--------------- COPEID FROM DIALOGS DEFAULT TRANSLATIONS -------------- ",
            'DIALOGS_ERROR': "Error",
            'DIALOGS_ERROR_MSG': "An unknown error has occurred.",
            'DIALOGS_CLOSE': "Close",
            'DIALOGS_PLEASE_WAIT': "Please Wait",
            'DIALOGS_PLEASE_WAIT_ELIPS': "Please Wait...",
            'DIALOGS_PLEASE_WAIT_MSG': "Waiting on operation to complete.",
            'DIALOGS_PERCENT_COMPLETE': "% Complete",
            'DIALOGS_NOTIFICATION': "Notification",
            'DIALOGS_NOTIFICATION_MSG': "Unknown application notification.",
            'DIALOGS_CONFIRMATION': "Confirmation",
            'DIALOGS_CONFIRMATION_MSG': "Confirmation required.",
            'DIALOGS_OK': "OK",
            'DIALOGS_YES': "Yes",
            'DIALOGS_NO': "No",
            '_communicationsCategory__': ' ',
            "_communicationsCategory_shortnotice_": "Short Notice",
            "_communicationsCategory_sale_": "Sale",
            "_communicationsCategory_twoway_": "Two-way Texting",
            "_communicationsCategory_reminder_": "Reminder",
            "_communicationsCategory_triggered_": "Triggered Messages",
            "_communicationsCategory_latepayment_": "Late Payment",
            "_communicationsCategory_educational_": "Educational",
            "_communicationsCategory_coupons_": "Coupons",
            "_communicationsCategory_reviews_": "Reviews",
            "_communicationsCategory_survey_": "Survey",
            "_communicationsCategory_newsletter_": "Newsletter",
            "_communicationsCategory_recall_": "Recalls",
            "_communicationsCategory_recalls_": "Recalls",
            "_communicationsCategory_missed_": "Missed Appointment",
            "_communicationsCategory_birthday_": "Birthday Messages",
            "_communicationsCategory_seasonal_": "Seasonal Greetings",
            "_communicationsCategory_gateway:reply_": "Auto Response by Autoremind",
            "_phonecell_": "Cell Phone",
            "_phonehome_": "Home Phone",
            "_phonework_": "Work Phone",
            "_phonealt_": "Alt. Phone",
            "_email_": "Email",
            "_voice_": "Phone",
            "_sms_": "Phone",
            "_media_sms_": "TEXT",
            "_media_voice_": "VOICE",
            "_media_email_": "EMAIL",
            "_PermissionsHeader_": "Permissions",
            "_centralMessageState_initiating_": "Initating",
            "_centralMessageState_sent_": "Sent",
            "_centralMessageState_delivered_": "Delivered",
            "_centralMessageState_failed_": "Failed",
            "_centralMessageState_expired_": "Expired",
            "_centralMessageState_blocked_": "Blocked",
            "_centralMessageState_reschedule_": "Reschedule",
            "_ResellerCustomersHeader_": "Customers",
            "_ResellerCollateralHeader_": "Collateral",
            "_ResellerSalesHeader_": "Sales",
            "_birthdayWidget_": "Birthday greetings was sent today",
            "_DashboardWidgetHeader_resellerInTrial_": "In trial right now",
            "_DashboardWidgetHeader_resellerLeads_": "Total number of leads",
            "_DashboardWidgetHeader_resellerPayingCustomers_": "Paying customers",
            "_DashboardWidgetHeader_salesMessages_": "Sales Messages",
            "_communicationsMissedReport_": "Missed Appointment Report",
            "_communicationsRecallsReport_": "Recalls Report",
            "_communicationsSurveyReport_": "Survey Report",
            "_unsubscribeReport_": "Unsubscribe Report",
            "_resellerWidget_": "Total number of leads",
            "_newsWidget_": "NEWS",
            "_supportWidget_": "SUPPORT",
            "_messagesSentTodayWidget_": "Messages sent today",
            "_messagesSent7DaysWidget_": "Messages sent last 7 days",
            "_messagesSent30DaysWidget_": "Messages sent last 30 days",
            "_sale_Report_": "Sale Report",
            "_seasonal_Report_": "Seasonal Report",
            "_messaging_Report_": "Messaging Report",
            "_shortnotice_Report_": "Short Notice Report",
            "_newsletter_Report_": "Newsletter Report",
            "_birthday_Report_": "Birthday Report",
            "_reviews_Report_": "Reviews Report",
            "_latepayment_Report_": "Late Payment Report",
            "_survey_Report_": "Survey Report",
            "_todoReport_": "To-Do List",
            "_triggered_Report_": "Triggered Message Report",
            "_resellerPayingCustomers_": "Reseller Paying Customers",
            "_resellerLeads_": "Reseller Leads",
            "_resellerInTrial_": "Reseller In Trial",
            "_salesMessages_": "Sales Messages",
            '_UserNamePlaceholder_': 'Enter user name, email or phone no',
            "_todoTask_destinatorMissing_": "Report missing email, home phone and cell phone",
            "_todoTask_destinatorMissing_NOTE:": "ADD A STRING FOR EACH POSSIBLE TASK COMBINATIONS (MISSING HOME PHONE ONLY, MISSING EMAIL, ETC.)",
            "_todoTask_destinatorMissing_email_": "Ask for email address",
            "_todoTask_destinatorMissing_phoneHome_": "Ask for home phone number",
            "_todoOptionSample_destinatorMissing_": "Example: 8:00am John Doe: Ask for cellphone number and email address",
            "_todoTask_destinatorMissing_phoneCell_": "Ask for cell phone number",
            "_todoOption_destinatorMissing_": "Report missing email, home phone and cell phone",
            "_todoTask_destinatorMissing_phoneCell_phoneHome_emailInvalid_": "Ask for cell phone, home phone numbers and email address in valid format",
            "_todoTask_destinatorMissing_phoneCell_phoneHome_email_": "Ask for cell phone, home phone numbers and email address",
            "_todoTask_destinatorMissing_phoneHome_emailInvalid_": "Ask for home phone number and email address in valid format",
            "_todoTask_destinatorMissing_phoneHome_email_": "Ask for home phone number and email address",
            "_todoTask_destinatorMissing_phoneCell_emailInvalid_": "Ask for cell phone number and email address in valid format",
            "_todoTask_destinatorMissing_phoneCell_email_": "Ask for cell phone number and email address",
            "_todoTask_destinatorMissing_emailInvalid_": "Ask for email address (in valid format)",
            "_todoTask_birthdayWithIn2Weeks_today_": "Birthday today: {0}",
            "_todoTask_birthdayWithIn2Weeks_": "Birthday coming up: {0}",
            "_todoOptionSample_birthdayWithIn2Weeks_": "Example: 8:00am John Doe: Birthday coming up: 02/28/16",
            "_todoTask_destinatorMissing_phoneCell_phoneHome_": "Ask for cell phone and home phone numbers",
            "_todoTask_completeHomeAddress_": "Report if the home address is note complete",
            "_todoTask_destinator6MonthNoUpdate_": "Ask to update email, home phone or cell phone since not updated the last 6 months",
            "_todoOptionSample_destinator6MonthNoUpdate_": "Example: 8:00am John Doe: Ask to update email, home phone or cell phone since not updated the last 6 months",
            "_todoOption_recalls_": "Recalls",
            "_todoOption_destinator6MonthNoUpdate_": "Report if email, home phone or cell phone is not updated in more than 6 months",
            "_todoOptionSample_completeHomeAddress_": "Example: 8:00am John Doe: Ask for full home address",
            "_todoTask_recalls_header": "Recalls",
            "_todoOption_missedAppointments_": "Missed appointments",
            "_todoReport_taskGenerator_skipped_": "No tasks generated for that day",
            "_todoReport_taskGenerator_emptyToday_": "No tasks today",
            "_todoReport_taskGenerator_pending_": "Tasks being generated...",
            "_todoOption_todoOptionSampleHeader_": "Example: 8:00am John Doe",
            "_todoTask_missedAppointments_header_": "Missed Appointments",
        };
        var person_translation = {
            "_Patient_": "Patient",
            "_Patients_": "Patients",
            "_patients_": "patients",
            "_pets_": "pets",
            "_patientContactStatisticsReport_": "Patient Contact Statistics report",
            "_todoOption_birthdayWithIn2Weeks_": "Report if the patient has a birthday with in 2 weeks of the appointment",
            "_todoTask_recalls_": "{0} patients in the recall process need to be checked",
            "_todoOptionSample_recalls_": "Example: 23 patients in the recall process need to be checked",
            "_todoTask_missedAppointments_": "{0} patients missed and cancelled appointments needs to be checked",
            "_todoOptionSample_missedAppointments_": "Example: 12 patients missed and cancelled appointments needs to be checked",
        };
        var vets_translation = {
            '_Patient_': 'Client',
            '_Patients_': 'Clients',
            "_patients_": "clients",
            "_pets_": "pets",
            "_patientContactStatisticsReport_": "Client Contact Statistics report",
            "_todoOption_birthdayWithIn2Weeks_": "Report if the client has a birthday with in 2 weeks of the appointment",
            "_todoTask_recalls_": "{0} clients in the recall process need to be checked",
            "_todoOptionSample_recalls_": "Example: 23 clients in the recall process need to be checked",
            "_todoTask_missedAppointments_": "{0} clients missed and cancelled appointments needs to be checked",
            "_todoOptionSample_missedAppointments_": "Example: 12 clients missed and cancelled appointments needs to be checked",
        };
        var translation_person = angular.merge({}, default_translation, person_translation);
        var translation_vets = angular.merge({}, default_translation, vets_translation);
        $translateProvider.translations('en_person', translation_person);
        $translateProvider.translations('en_vets', translation_vets);
        $translateProvider.preferredLanguage('en');
    }]);
//# sourceMappingURL=autoremind.app.js.map